(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-modal-open]');
    if (openBtn) {
      const modal = document.getElementById(openBtn.dataset.modalOpen);
      if (modal) {
        modal.showModal();
        const cd = modal.querySelector('[data-countdown]');
        if (cd && !cd.dataset.started) {
          cd.dataset.started = 'true';
          startCountdown(cd);
        }
      }
    }

    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      const modal = closeBtn.closest('dialog');
      if (modal) modal.close();
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.tagName === 'DIALOG') {
      e.target.close();
    }
  });

  document.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest('.qv-size-btn:not(.qv-size-btn--unavailable)');
    if (sizeBtn) {
      const group = sizeBtn.closest('.qv-sizes');
      group.querySelectorAll('.qv-size-btn').forEach((b) => b.classList.remove('qv-size-btn--selected'));
      sizeBtn.classList.add('qv-size-btn--selected');
    }
  });

  function startCountdown(el) {
    let total =
      parseInt(el.dataset.h || 14, 10) * 3600 +
      parseInt(el.dataset.m || 49, 10) * 60 +
      parseInt(el.dataset.s || 53, 10);

    const hEl = el.querySelector('.qv-cd-h');
    const mEl = el.querySelector('.qv-cd-m');
    const sEl = el.querySelector('.qv-cd-s');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      if (total <= 0) return;
      total--;
      hEl.textContent = pad(Math.floor(total / 3600));
      mEl.textContent = pad(Math.floor((total % 3600) / 60));
      sEl.textContent = pad(total % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-modal-open]');
    if (openBtn) {
      const modal = document.getElementById(openBtn.dataset.modalOpen);
      if (modal) {
        modal.showModal();
        const cd = modal.querySelector('[data-countdown]');
        if (cd && !cd.dataset.started) {
          cd.dataset.started = 'true';
          startCountdown(cd);
        }
      }
    }

    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      const modal = closeBtn.closest('dialog');
      if (modal) modal.close();
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.tagName === 'DIALOG') {
      e.target.close();
    }
  });

  document.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest('.qv-size-btn:not(.qv-size-btn--unavailable)');
    if (sizeBtn) {
      const group = sizeBtn.closest('.qv-sizes');
      group.querySelectorAll('.qv-size-btn').forEach((b) => b.classList.remove('qv-size-btn--selected'));
      sizeBtn.classList.add('qv-size-btn--selected');
    }
  });

  function startCountdown(el) {
    let total =
      parseInt(el.dataset.h || 14, 10) * 3600 +
      parseInt(el.dataset.m || 49, 10) * 60 +
      parseInt(el.dataset.s || 53, 10);

    const hEl = el.querySelector('.qv-cd-h');
    const mEl = el.querySelector('.qv-cd-m');
    const sEl = el.querySelector('.qv-cd-s');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      if (total <= 0) return;
      total--;
      hEl.textContent = pad(Math.floor(total / 3600));
      mEl.textContent = pad(Math.floor((total % 3600) / 60));
      sEl.textContent = pad(total % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  } catch(e) { console.error(e); }
})();
})();
